//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import { commonService } from "../../_services";
import config from '../../config';
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import { ideasActions, categoryActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
    },
    actionRoot: {
        margin: 0,
        padding: theme.spacing(1)
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    tableImg: {
        width: '50px',
        height: '50px',
        position: 'relative',
        padding: '3px'
    },

    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    },
    borderedImgTable: {
        position: 'relative',
        width: '52px',
        height: '52px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '8px',
        marginRight: '8px'
    }
});

class Ideas extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            ideas: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            ideaAdd: false,
            shopKeeperData: [],
            title: '',
            ideaError: '',
            ideaSuccess: '',
            getIdeasList: [],
            addCat: false,
            editingCatId: '',
            editingCatTitle: '',
            editingCatStatus: '',
            editingCatHold: false,
            ideaImage: '',
            allActiveCat: [],
            allSubCategories: [],
            perPage: config.perPageData,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the ideas data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(ideasActions.getIdeasList(apiConstants.GET_IDEAS, postData));
        dispatch(categoryActions.getAllActiveCategory(apiConstants.GET_ALL_ACTIVE_CATEGORIES_FOR_ADMIN));

    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        const { dispatch } = props;
        if (props.deleteIdea.deleteIdea !== undefined &&
            props.deleteIdea.deleteIdea.data !== undefined &&
            props.deleteIdea.deleteIdea.data.data !== undefined &&
            props.deleteIdea.deleteIdea.data.success === true) {

            if (this.state.triggerDelete === true) {

                this.setState({ triggerDelete: false });
                this.setState({ deletingIdea: '', openDeleteCat: false });

                let postData = {};
                postData.page = this.state.currentPage;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;
                dispatch(ideasActions.getIdeasList(apiConstants.GET_IDEAS, postData));
            }
        }

        //check if idea already exist with same name
        if (
            props.saveIdea !== undefined &&
            props.saveIdea.savedIdea !== undefined &&
            props.saveIdea.savedIdea === false
        ) {
            this.setState({ ideaError: 'idea with same name already exist!!', ideaSuccess: '', ideaImage_error: '', ideaDescriptionError: '' })
        }

        //IF idea ADDED SUCCESSFULLY
        if (
            props.saveIdea !== undefined &&
            props.saveIdea.savedIdea !== undefined &&
            props.saveIdea.savedIdea.data !== undefined &&
            props.saveIdea.savedIdea.data.success !== undefined &&
            props.saveIdea.savedIdea.data.success === true
        ) {
            const thisHolder = this;
            if (thisHolder.state.addCat === true) {
                this.setState({ ideaSuccess: 'idea added successfully!!', ideaError: '', ideaImage_error: '', ideaDescriptionError: '' });

                setTimeout(function () {

                    thisHolder.setState({ ideaSuccess: '', ideaError: '', ideaImage_error: '', ideaDescriptionError: '' });
                    thisHolder.closeAddCatPop();

                    let postData = {};
                    postData.page = thisHolder.state.currentPage;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = thisHolder.state.perPage;
                    dispatch(ideasActions.getIdeasList(apiConstants.GET_IDEAS, postData));
                }, 2000);
            }
        }

        //get all active categories
        if (props.getAllActiveCat !== undefined &&
            props.getAllActiveCat.activeCat !== undefined &&
            props.getAllActiveCat.activeCat.data !== undefined &&
            props.getAllActiveCat.activeCat.data.data) {
            this.setState({ allActiveCat: props.getAllActiveCat.activeCat.data.data });
        }


        // GET LIST OF IDEA LIST SUCCESS
        if (props.getIdeasList !== undefined &&
            props.getIdeasList.getIdeasList !== undefined &&
            props.getIdeasList.getIdeasList.data !== undefined
        ) {
            const ideaDataReceived = props.getIdeasList.getIdeasList.data;
            this.setState({
                getIdeasList: ideaDataReceived,
                totalPage: ideaDataReceived.pagination.totalPages,
                totalDataCount: ideaDataReceived.pagination.totalCount,
            })
        }

        // GET LIST OF ACTIVE SUB CATEGORIES
        if (props.getAllSubCategory !== undefined &&
            props.getAllSubCategory.getSubCatList !== undefined &&
            props.getAllSubCategory.getSubCatList.data !== undefined &&
            props.getAllSubCategory.getSubCatList.data.type === "get_sub_categories_by_id"
        ) {

            const subCatDataReceived = props.getAllSubCategory.getSubCatList.data;
            this.setState({
                allSubCategories: subCatDataReceived,
            })
        }

    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });
        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;
        dispatch(ideasActions.getIdeasList(apiConstants.GET_IDEAS, postData));
    }


    //remove image while editing a category
    removeMainImage = () => { this.setState({ editingCatLogo: '' }); }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (ideas, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddShopkeeper' })
        }
        //this.setState({ ideas, [type]: true })
    };


    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            ideas: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    //on change set category title to state
    onChangeCatTitle = (e) => {
        if (e.target.type === "file") {

            var extArr = ["image/jpeg", "image/jpg", "image/png"];
            const files = e.target.files;
            const target = e.target;
            var forimgState = [target.name + "_error"];


            if (extArr.indexOf(files[0].type) > -1) {

                this.setState({ [target.name]: files[0] });

                // let img = new Image()
                // img.src = window.URL.createObjectURL(e.target.files[0])
                // img.onload = () => {

                //     if (img.width === 161 && img.height === 139) {
                //         this.setState({ [target.name]: files[0] });
                //         this.setState({ [forimgState]: "" });
                //         // upload logic here
                //     }
                //     else {
                //         this.setState({ [forimgState]: "Image dimension should not be greater then 169*139!!" });
                //         target.value = null;
                //         this.setState({ [target.name]: '' })
                //     }
                // }


            } else {
                this.setState({ [forimgState]: "One of the file type not suported" })
                e.target.value = null;
                this.setState({ [e.target.name]: '' })
            }
        }
        else { this.setState({ [e.target.name]: e.target.value }); }
    }

    //close add category popup
    closeAddCatPop = () => {
        this.setState({
            ideaSuccess: '',
            ideaAdd: false,
            title: '',
            addCat: false
        });
    }

    handleChangeCategory = (e) => {
        this.setState({ [e.target.name]: e.target.value });

        const { dispatch } = this.props;
        let postData = {};
        postData.catId = e.target.value;

        dispatch(categoryActions.getAllSubCategory(apiConstants.GET_ALL_SUB_CATEGORIES_BY_ID_FOR_ADMIN, postData));
    }

    //save idea to collection
    handleSubmit = () => {
        const { dispatch } = this.props;
        this.setState({ ideaError: '', ideaImage_error: '', ideaDescriptionError: '' });
        const { title, ideaImage, description, categories, sub_categories } = this.state;
        if (title === undefined || title === '') { this.setState({ ideaError: 'idea title required!!' }) }
        else if (description === undefined || description === '') { this.setState({ ideaDescriptionError: 'idea decription required!!' }) }
        else if (ideaImage === undefined || ideaImage === '') { this.setState({ ideaImage_error: 'idea Image required!!' }) }
        else {

            this.setState({ ideaError: '', addCat: true, ideaImage_error: '', ideaDescriptionError: '' })

            const postData = {};
            postData.title = title;
            postData.description = description;
            postData.categories = categories;
            postData.sub_categories = sub_categories;


            //add to form data to send over api
            const logoImage = new FormData();
            logoImage.append('ideaImage', ideaImage);

            commonService.withTokenAndFormData(apiConstants.SAVE_IDEA_IMAGE, logoImage).then(
                res => {
                    //get image title from response
                    if (res.data !== undefined && res.data.data !== undefined) {
                        postData.idea_image = res.data.data;
                    }
                    // save idea data to cololection
                    dispatch(ideasActions.saveIdea(apiConstants.SAVE_IDEAS, postData));
                },
                error => { }
            );
        }
    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    openAddCategory = () => {
        this.setState({
            ideaAdd: !this.state.ideaAdd,
            ideaSuccess: '',
            title: '',
            parentcat: '',
            ideaImage: '',
            ideaImage_error: '',
            addCat: false
        });

    }

    // handleClose = () => {
    //     this.setState({ ideaAdd: !this.state.ideaAdd })
    // };


    deletePopupOpen = (ideaId) => {
        this.setState({ deletingIdea: ideaId, openDeleteCat: true });
    }

    closeDeletePopup = (ideaId) => {
        this.setState({ deletingIdea: '', openDeleteCat: false });
    }

    // after conform click to delete idea
    deletingCatRecord = () => {
        this.setState({ triggerDelete: true });

        const { dispatch } = this.props;
        const postData = {};
        postData.ideaId = this.state.deletingIdea;
        dispatch(ideasActions.deleteIdeas(apiConstants.DELETE_IDEA, postData));
    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { classes } = this.props;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_IDEAS}
                                </li>
                                <li style={{ paddingLeft: "800px" }}>
                                    <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_IDEAS}</h1>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddCategory()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">

                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_TITLE}</th>
                                                    <th>{siteConstants.GEN_DESCRIPTION}</th>
                                                    <th>{siteConstants.GEN_IMAGE}</th>
                                                    <th scope="col" width="10%">{siteConstants.LABEL_STATUS}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.getIdeasList.data != undefined &&
                                                        this.state.getIdeasList.data.length > 0 ?
                                                        this.state.getIdeasList.data.map((thisidea, index) => {
                                                            let stText = 'Active';
                                                            if (thisidea.status === 0) { stText = 'Deactive'; }

                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisidea.title}</td>
                                                                    <td> {thisidea.description}</td>
                                                                    <td>
                                                                        {
                                                                            thisidea.idea_image !== undefined && thisidea.idea_image ? (
                                                                                <div className={classes.borderedImgTable}>
                                                                                    <img src={`${config.imgPath}` + '/uploads/ideas/' + thisidea.idea_image} className={classes.tableImg} />
                                                                                </div>
                                                                            ) : '--'
                                                                        }

                                                                    </td>

                                                                    <td>{stText}</td>
                                                                    <td>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.deletePopupOpen(thisidea._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="6" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add idea popup */}
                    <Dialog
                        open={this.state.ideaAdd}
                        aria-labelledby="idea-title"
                        aria-describedby="save-idea-description"
                    >
                        <DialogTitle id="crop-image-dialog-title" className={classes.root}>{siteConstants.LABEL_ADD_IDEAS}</DialogTitle>
                        <DialogContent className={classes.contentRoot}>
                            <div class="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.GEN_TITLE}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder={siteConstants.GEN_TITLE}
                                            className="form-control"
                                            name="title"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.ideaError}</p>
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.GEN_DESCRIPTION}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder={siteConstants.GEN_DESCRIPTION}
                                            className="form-control"
                                            name="description"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.ideaDescriptionError}</p>
                                    </div>
                                </div>


                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_IDEA_IMAGE}</label>
                                        <input
                                            type="file"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            className="form-control"
                                            name="ideaImage"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.ideaImage_error}</p>
                                        <p style={{ color: 'green' }}>{this.state.ideaSuccess}</p>
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_SELECT_PARENT_CATEGORY}</label>
                                        <select
                                            className="form-control"
                                            onChange={(e) => this.handleChangeCategory(e)}
                                            name="categories"
                                        >
                                            <option value=""> </option>
                                            {
                                                this.state.allActiveCat != undefined &&
                                                    this.state.allActiveCat.length > 0 ?
                                                    this.state.allActiveCat.map((thisCat, index) => {
                                                        let stText = 'Active';
                                                        if (thisCat.status === 0) { stText = 'Deactive'; }

                                                        return <option value={thisCat._id}> {thisCat.categoryTitle} </option>
                                                    }) : ''
                                            }
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-6">
                                <div className="form-group">
                                    <label>{siteConstants.LABEL_PRODUCT_SUB_CATEGORY}</label>
                                    <select
                                        className="form-control"
                                        name="sub_categories"
                                        onChange={(e) => this.handleChange(e)}
                                    >
                                        <option>----</option>
                                        {/* loop through all the available categories */}

                                        {
                                            this.state.allSubCategories !== undefined &&
                                            this.state.allSubCategories.data !== undefined &&
                                            this.state.allSubCategories.data.length > 0 &&
                                            this.state.allSubCategories.data.map((cat) => {
                                                //let temp = (cat.parentCat !== undefined && cat.parentCat !== "")?"....":""
                                                return <option value={cat._id}>
                                                    {/* {temp} */}
                                                    {cat.categoryTitle}
                                                </option>
                                            })
                                        }
                                    </select>
                                </div>
                                <p className={classes.error}>{this.state.productSubCategories_error}</p>
                            </div>
                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeAddCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* edit idea popup */}


                    {/* add banner popup */}
                    {/* notify about delete */}
                    <Dialog open={this.state.openDeleteCat} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>
                            {siteConstants.BTN_DELETE}
                        </DialogTitle>
                        <DialogContent>
                            {siteConstants.LABEL_SURE_DELTE_TAX_RECORD}
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingCatRecord(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>


                    <Footer />
                </div>



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, saveIdea, getIdeasList, addIdea, deleteIdea, getAllActiveCat,getAllSubCategory } = state;
    return {
        language,
        saveIdea,
        getIdeasList,
        addIdea,
        deleteIdea,
        getAllActiveCat,
        getAllSubCategory
    };
}

export default connect(mapStateToProps)(withStyles(styles)(Ideas));
